import { createRoute } from '@tanstack/react-router';
import ToursPage from '@/features/dashboard/tours/pages/ToursPage.tsx';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import { listSearchSchema } from '@/components/table/routes/listSearchParams.ts';

export const toursIndexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/',
  component: ToursPage,
  validateSearch: listSearchSchema,
});

export const toursDashboardRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/dashboard',
  component: ToursPage,
  validateSearch: listSearchSchema,
});

export const toursRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/tours',
  component: ToursPage,
  validateSearch: listSearchSchema,
});
